module.exports = __webpack_public_path__ + "static/media/storage.d9f3421c.png";